export default {
    name: 'precedingCategory',
    serverName: '​/api/v1/normative_calculator/preceding_culture_category/',
    apiUrl: '/api/v1/normative_calculator/preceding_culture_category/'
};
